import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Download, Zap } from 'lucide-react';
export function PricingSection() {
  return <Section id="pricing" className="bg-[#0A0A0A] pb-32" data-id="element-183">
      <div className="max-w-3xl mx-auto text-center" data-id="element-184">
        <div className="mb-12" data-id="element-185">
          <span className="text-4xl md:text-5xl font-bold text-gray-500 line-through tracking-tighter block mb-1" data-id="element-186">
            $27
          </span>
          <span className="text-7xl md:text-8xl font-black text-[#22C55E] tracking-tighter block mb-2" data-id="element-187">
            $6.39
          </span>
          <span className="text-xl text-gray-400 uppercase tracking-widest font-medium" data-id="element-188">
            Pago Único —{' '}
            <span className="text-[#22C55E] font-bold" data-id="element-189">76% OFF</span>
          </span>
        </div>

        <div className="bg-[#1A1A1A] rounded-xl p-6 mb-12 inline-block" data-id="element-190">
          <p className="text-gray-300 text-lg" data-id="element-191">
            Porque esto no compite con "meditaciones gratis". <br data-id="element-192" />
            <strong className="text-white" data-id="element-193">
              Compite con el costo de perder un día completo por estar en modo
              reacción.
            </strong>
          </p>
        </div>

        <div className="space-y-8" data-id="element-194">
          <p className="text-2xl font-bold text-white" data-id="element-195">
            Si hoy estás en ese punto donde dices: <br data-id="element-196" />
            <span className="text-[#EF4444] italic" data-id="element-197">
              "Necesito bajarle ya porque si no, exploto o la riego"…
            </span>
          </p>

          <Button size="xl" className="w-full md:w-auto min-w-[320px] shadow-[0_0_40px_rgba(37,99,235,0.4)]" href="https://helproutines.com/cart/44635947597894:1" data-id="element-198">
            Quiero Reset Operativo (7 Min) — $6.39
          </Button>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500 pt-8" data-id="element-199">
            <span className="flex items-center gap-2" data-id="element-200">
              <ShieldCheck className="w-4 h-4" data-id="element-201" /> Pago seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-202">
              <Download className="w-4 h-4" data-id="element-203" /> Descarga inmediata
            </span>
            <span className="flex items-center gap-2" data-id="element-204">
              <Zap className="w-4 h-4" data-id="element-205" /> Sin suscripción
            </span>
          </div>
        </div>
      </div>
    </Section>;
}